import {
  JsonapiEntity,
  attribute,
  entity,
  meta,
} from '@talisdev/jsonapi-transformers';

export enum UserJobRoleDescription {
  ACADEMIC = 'academic',
  TEACHER = 'teacher',
  LECTURER = 'lecturer',
  EDUCATIONAL_SUPPORT = 'educational_support',
  UNDERGRADUATE = 'undergraduate',
  POSTGRADUATE = 'postgraduate',
  RESEARCHER = 'researcher',
  LIBRARIAN = 'librarian',
  LEARNING_TECHNOLOGIST = 'learning_technologist',
  NON_TEACHING_FACULTY = 'non_teaching_faculty',
}

export enum UserInstitutionalRole {
  STAFF = 'Library Staff',
  ACADEMIC = 'Academic',
  STUDENT = 'Student',
}

@entity({ type: 'users' })
export class UserRecord extends JsonapiEntity<UserRecord> {
  @attribute() active_pid: string;
  @attribute() first_name: string;
  @attribute() surname: string;
  @attribute() email: string;
  @attribute() additional_emails?: string[];
  @attribute() job_role_description?: UserJobRoleDescription;
  @attribute() is_profile_private?: boolean;
  @attribute() date_bookmark_extension_alert_dismissed?: string;
  @meta({ name: 'devolved_authorisations' })
  devolvedAuthorisations?: string[];
  @meta({ name: 'institutional_role' })
  institutionalRole?: UserInstitutionalRole;
  @meta({ name: 'profile_url' }) profileUrl?: string;

  // derived properties
  get full_name(): string {
    if (this.first_name && this.surname) {
      return `${this.first_name} ${this.surname}`;
    }
    return undefined;
  }
}
